import { useEffect, useState } from "react";
import { useLocale } from "../i18n/localeContext";

type StrapiFetcher = (locale: string) => Promise<any>;

export function useStrapiContent(fetcher: StrapiFetcher) {
  const { locale } = useLocale();
  const [content, setContent] = useState<any>(null);
  const [isLoadingContent, setIsLoadingContent] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let cancel = false;
    setHasError(false);
    setIsLoadingContent(true);

    const timeoutId = setTimeout(() => {
      if (!cancel) {
        setContent(null);
        setIsLoadingContent(false);
        setHasError(locale === "en");
      }
    }, 3000);

    fetcher(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) {
          clearTimeout(timeoutId);
          setContent(data);
          setIsLoadingContent(false);
        }
      })
      .catch(() => {
        if (!cancel) {
          clearTimeout(timeoutId);
          setContent(null);
          setIsLoadingContent(false);
          setHasError(locale === "en");
        }
      });

    return () => {
      cancel = true;
      clearTimeout(timeoutId);
    };
  }, [locale]); // fetcher es estable (import de content.js)

  return { content, isLoadingContent, hasError, setHasError, setIsLoadingContent };
}

export function renderSectionScheduleSubtitle(
  page: any,
  seccion?: string,
  horario?: string[] | string,
): string {
  const scheduleText = Array.isArray(horario) ? horario.join("") : horario ?? "";
  return `${page?.section_label || "Sección:"} ${seccion} - ${page?.schedule_label || "Horario:"} ${scheduleText}`;
}
